import { jsx as t, jsxs as a } from "react/jsx-runtime";
import { useId as _ } from "react";
import { c as z } from "../clsx-OuTLNxxd.js";
import { C as k } from "../Check-Cw4qhL84.js";
import "../List.css?__remix_sideEffect__";const h = "_list_cpz7k_1",I = "_listItem_cpz7k_10",d = "_iconWrapper_cpz7k_15",s = {
    list: h,
    listItem: I,
    iconWrapper: d,
    "size--s": "_size--s_cpz7k_23",
    "size--m": "_size--m_cpz7k_35"
  },W = ({
    className: i,
    direction: c,
    items: l,
    size: e = "m",
    ...r
  }) => {
    const o = _(),m = c ? { flexDirection: c } : {};
    return /* @__PURE__ */t(
      "ul",
      {
        className: z(s.list, s[`size--${e}`], i),
        style: m,
        ...r,
        children: l.map((p, n) => /* @__PURE__ */a("li", { className: s.listItem, children: [
          /* @__PURE__ */t("span", { className: s.iconWrapper, children: /* @__PURE__ */t(k, { className: s.check, color: "blue", size: e }) }),
          /* @__PURE__ */t("span", { children: p })]
        }, `list-${o}-item-${n}`))
      }
    );
  };
export {
  W as List };